module.exports = __webpack_public_path__ + "static/media/general_campaign_icon.b3cecb82.png";